function AddressesComponent({ order }) {
    return (
        <div className="bg-gray-50 p-6">
            <div className="space-y-10 md:space-y-0 md:flex justify-between">
                <div className="md:w-1/2">
                    <h4 className="font-medium pb-4">Billing Address</h4>
                    {Object.keys(order.billing).map((key) => (
                        <p key={key} className="text-sm text-gray-500">
                            {order.billing[key]}
                        </p>
                    ))}
                </div>
                <div className="md:w-1/2">
                    <h4 className="font-medium pb-4">Shipping Address</h4>
                    {Object.keys(order.shipping).map((key) => (
                        <p key={key} className="text-sm text-gray-500">
                            {order.shipping[key]}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AddressesComponent
